import {
  AnalyticsEventParam,
  convertDateToString,
  determineVideoQuality,
  PlayerEvent,
} from '@accedo/one-plugin-sdk';

import { Item, MediaSubtype } from '#/client';
import { adsStore } from '#/plugins/ads/adsStore';

// based on AnalyticsPlayerParams from plugin SDK
export const createPlayerPayload = (player?: HTMLVideoElement | null) => {
  if (!player) {
    return {};
  }
  // TODO: some properties should be reached from players (WIP)
  // this should be updated after the implementation for these are ready

  return {
    //[AnalyticsEventParam.Bitrate]: player.?,
    //[AnalyticsEventParam.Fullscreen]: player.?,
    [AnalyticsEventParam.Position]: Math.trunc(player.currentTime),
    [AnalyticsEventParam.Quality]: determineVideoQuality(
      player.videoWidth,
      player.videoHeight
    ),
    //[AnalyticsEventParam.VideoPlayer]: player.?
    [AnalyticsEventParam.Volume]: player.volume,
  };
};

// based on AnalyticsItemParams from plugin SDK
export const createItemPayload = (item?: Item) => {
  if (!item) {
    return {};
  }
  // TODO: some properties should be reached from resource
  // this should be updated after clarification
  // TODO#eventParams: we should fall back to `null` instead of `undefined` for all

  // TODO#analytics: date conversion topic should be reconsidered later
  const releaseDate = item.releaseDate
    ? convertDateToString(new Date(item.releaseDate))
    : undefined;

  return {
    // TODO: for current response - customer independent solution needed
    [AnalyticsEventParam.AirDate]: releaseDate,
    // Slight a hack: let's use item title as channelName, when it's a LIVE_CHANNEL subtype.
    // If a better data is available for this purpose it should be used instead.
    [AnalyticsEventParam.ChannelName]:
      item.subtype === MediaSubtype.LiveChannel ? item.title : undefined,
    [AnalyticsEventParam.ContentId]: item.id,
    [AnalyticsEventParam.Description]: item.description,
    [AnalyticsEventParam.EpisodeNumber]: item.episode?.number,
    [AnalyticsEventParam.Extras]: item.extras,
    //[AnalyticsEventParam.FrameRate]: item.?,
    //[AnalyticsEventParam.FullEpisode]: item.?,
    [AnalyticsEventParam.Genre]: item.genres,

    // TODO: duration is `number | string` for some reason (?)
    [AnalyticsEventParam.Length]: Number(item.video.duration ?? '0'),
    [AnalyticsEventParam.LiveStream]: item.subtype === MediaSubtype.LiveChannel,

    // TODO: for HMN response - customer independent solution needed
    [AnalyticsEventParam.Program]: item.tvShow?.title,

    // TODO: for current response - customer independent solution needed
    [AnalyticsEventParam.PublishDate]: releaseDate,
    //[AnalyticsEventParam.Publisher]: item.?,

    // TODO: the same situation for SeasonNumber as was for PublishDate
    // TODO: for HMN response - customer independent solution needed
    [AnalyticsEventParam.SeasonNumber]: item.tvShowSeason?.season.number,
    [AnalyticsEventParam.Title]: item.title,

    // TODO: this is a duplicate, should be removed, left here for backwards compatibility for now
    // should be mapped to program, but customer independent solution needed in the long term
    [AnalyticsEventParam.TvShowTitle]: item.tvShow?.title,
    [AnalyticsEventParam.Subtype]: item.subtype,
  };
};

// Don't fire end event in case of ad is ended, only fire it when the main content is ended
export const ignoreAnalytics = (eventType: string) =>
  adsStore.isInsideAd && eventType === PlayerEvent.Ended;
